<template>
  <ak-card-header>
    <div v-if="isOwnAccount()" class="pull-right">
      <ak-tooltip :placement="'left'" :has-arrow="false">
        <template #trigger>
          <a
            class="icon-action icon-action--inline icon-action--offset icon-cog color-grey-light"
            @click="changeWidget()"
          ></a>
        </template>
        Change Widget
      </ak-tooltip>
    </div>
    <h4 class="color-grey">
      {{ entityBranding('contacts.singular', 'Contact') }} Heat
    </h4>
  </ak-card-header>
  <ak-card-body :size="'flush'" class="scrollable">
    <router-link :to="{ name: 'allContacts' }" class="pointer one-whole">
      <div class="funnel c-skeleton-loading">
        <div
          class="funnel__item text-large flex--column"
          :class="{ 'bg-grey-lighter c-skeleton-loading__item': isLoading }"
        >
          <div>Cold</div>
          <strong v-if="!isLoading">{{ temperatures.cold }}</strong>
        </div>
        <div
          class="funnel__item text-large flex--column"
          :class="{ 'bg-grey-lighter c-skeleton-loading__item': isLoading }"
        >
          <div>Tepid</div>
          <strong v-if="!isLoading">{{ temperatures.tepid }}</strong>
        </div>
        <div
          class="funnel__item text-large flex--column"
          :class="{ 'bg-grey-lighter c-skeleton-loading__item': isLoading }"
        >
          <div>Warm</div>
          <strong v-if="!isLoading">{{ temperatures.warm }}</strong>
        </div>
        <div
          class="funnel__item text-large flex--column"
          :class="{ 'bg-grey-lighter c-skeleton-loading__item': isLoading }"
        >
          <div>Hot</div>
          <strong v-if="!isLoading">{{ temperatures.hot }}</strong>
        </div>
      </div>
    </router-link>
  </ak-card-body>
</template>

<script>
import { ref, onMounted, defineComponent } from 'vue'
import CardHeader from '@akerolabs/akero-vue/src/components/cards/CardHeader.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'
import { accountObj, agencyObj } from '@akerolabs/akero-vue/src/store'
import { isOwnAccount } from '@akerolabs/akero-vue/src/services/users'
import date from '@akerolabs/akero-vue/src/utils/date'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'

export default defineComponent({
  name: 'AkWidgetContactHeat',
  components: {
    [CardHeader.name]: CardHeader,
    [CardBody.name]: CardBody,
  },
  inheritAttrs: false,
  props: {
    /**
     * @type {Function}
     * @description Update the widget state
     */
    changeWidget: {
      type: Function,
      default: () => ({}),
    },
  },

  setup() {
    const startDate = '2012-01-01T00:00:00.000Z'
    const endDate = date().toISOString()
    const isLoading = ref(true)
    let temperatures = ref({
      cold: 0,
      tepid: 0,
      warm: 0,
      hot: 0,
    })

    const getStatData = async () => {
      isLoading.value = true
      let temperaturesData = {}
      const displayError = (ex) => {
        if (ex) console.log(ex)
        ToastProgrammatic.open({
          message: `Error failed to load contact heat data`,
          type: 'danger',
        })
      }
      try {
        const { data } = await request.post('/stats/contactheat', {
          account: accountObj()._id,
          agency: agencyObj()._id,
          startDate: startDate,
          endDate: endDate,
          heat: accountObj().settings.leads.score.heat,
        })
        temperaturesData = data.data
      } catch (ex) {
        displayError(ex)
      }
      temperatures.value = temperaturesData
      isLoading.value = false
    }

    /**
     * @description On mount fetch data
     */
    onMounted(async () => {
      await getStatData()
    })

    return {
      isLoading,
      isOwnAccount,
      getStatData,
      temperatures,
      entityBranding,
    }
  },
})
</script>
